import React from 'react';
import { menuData } from '../menuData';

const Menu = () => {
  return (
    <div className="bg-gray-50 py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-4xl font-extrabold text-center text-gray-900 mb-4">Our Menu</h1>
        <p className="text-center text-lg text-gray-600 mb-12">Fresh, Delicious, and Made with Love</p>
        
        {menuData.map((category, index) => (
          <div key={index} className="mb-12">
            <h2 className="text-3xl font-bold text-yellow-600 mb-6 pb-2 border-b-2 border-yellow-500">{category.category}</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {category.items.map((item, itemIndex) => (
                <div key={itemIndex} className="bg-white rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300 ease-in-out overflow-hidden">
                  <div className="p-6">
                    <div className="flex justify-between items-start">
                      <h3 className="text-xl font-semibold text-gray-800">{item.name}</h3>
                      <p className="text-xl font-bold text-yellow-700 whitespace-nowrap pl-4">{item.price}</p>
                    </div>
                    <p className="text-gray-600 mt-2">{item.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Menu;
